import { Link } from "react-router-dom";

import { NotificationList } from "../../features/notifications";

// NotificationListScreen — route landing for /notifications.
// Mounts under MainLayout. Uses canonical clients-header grammar
// (same visual system as Clients / Deals / Dashboard).

function NotificationListScreen() {
  return (
    <section
      className="clients-page feature-notifications"
      id="Csection"
      tabIndex="-1"
    >
      <div className="container">
        <section
          className="clients-overview"
          aria-label="Огляд сповіщень"
        >
          <header className="clients-header">
            <div className="clients-header__text">
              <h1 className="clients-header__title">Сповіщення</h1>
              <p className="clients-header__sub">
                Останні події щодо ваших обʼєктів, клієнтів та компанії.
              </p>
            </div>
            <div className="clients-header__actions">
              <Link
                to="/notifications/preferences"
                className="btn-more"
                data-feature="notification-settings-link"
              >
                <i className="fa-solid fa-gear" aria-hidden="true" />
                Налаштування сповіщень
              </Link>
            </div>
          </header>
        </section>

        <NotificationList />
      </div>
    </section>
  );
}

export default NotificationListScreen;
